<script type="ts">
    import {t} from 'i18n-js';
    import {fade} from 'svelte/transition';
    import {privacyUrl} from '../../nutsandwoods';
    import {EMAIL_REGEX, subscribe} from '../../parts/newsletter';
    import {isPhone} from '../../svelte/useragent';
    import Watcher from '../../watcher';

    import { onMount } from 'svelte';
    import Marquee from '../../marquee';

    const NO_ANIMATIONS = (globalThis as any).NO_ANIMATIONS;

    const SCOPE = {scope: 'Newsletter.Form'};

    let success = false, submitting = false, error = false;
    let email: string = '';

    async function submit() {
        try {
            submitting = true;
            await subscribe(email);
            success = true;
        } catch {
            error = true;
        } finally {
            submitting = false;
        }
    }

    onMount(() => {
        const watcher = new Watcher();
        const marqueeEles: NodeListOf<HTMLElement> = document.querySelectorAll('.newsletter .effect-marquee');
        if (NO_ANIMATIONS) return;
        marqueeEles.forEach((marquee: HTMLElement) => {
            new Marquee(marquee);
            watcher.add({
                element: marquee,
                onAppearing(element, direction) {
                    element.classList.add('effect-marquee-show');
                    const visible = element.classList.contains('effect-marquee-show');
                    if(!visible)
                        setTimeout(() => element.classList.add('effect-marquee-show'));
                },
                onDisappeared(element, direction) {
                    if (direction == -1) {
                        element.classList.remove('effect-marquee-show');
                    }
                },
            });
        });
    });
</script>

<div class="newsletter">
    <h3 class="only-section effect-marquee"
        style:--baseTime={$isPhone ? '5s' /* niedriger setzen, wenn marquee schneller laufen soll */ : null}
    >{
        t($isPhone ? 'become_part' : 'discount', SCOPE)
    }</h3>
    <!-- svelte-ignore a11y-missing-attribute -->
    <img
        class="only-popup"
        src={$isPhone ?
                "/assets/img/phone/parts/newsletter-bg.webp" :
                "/assets/img/desktop/parts/newsletter-bg.webp"}
        width="100px"
    >
{#if success}
    <header transition:fade|local class="success">
        <h4>{t('success', SCOPE)}</h4>
        <p>{t('confirm', SCOPE)}</p>
    </header>
{:else if submitting}
    <header transition:fade|local class="submitting">
        <h4>{t('processing', SCOPE)}</h4>
    </header>
{/if}
{#if !success}
    <header transition:fade|local class="info">
        <h4 class="only-popup">{
            t('cta-popup', SCOPE)
        }</h4>
    </header>
    <form transition:fade|local
        on:submit|preventDefault={submit}
    >
        <input type="email" name="email"
            autocomplete="off"
            placeholder={t('email', SCOPE)}
            bind:value={email}
        /><!--
     --><input class="button" type="submit" value={t($isPhone ? 'submit_phone' : 'submit', SCOPE)}
            disabled={!email.match(EMAIL_REGEX) || submitting}
        />
    {#if error}
        <p transition:fade|local>{t('error', SCOPE)}</p>
    {/if}
    </form>
{/if}
    <a class="only-popup" target="_blank" href="{privacyUrl('newsletter')}">{t('privacy', SCOPE)}</a>
</div>
